<section class="max-w-lg mx-auto bg-white shadow-xl rounded-xl overflow-hidden border border-gray-300">
  <header class="bg-gradient-to-r from-gray-900 to-gray-800 text-gray-100 text-center py-8 px-6">
    <h1 class="text-4xl font-bold leading-tight drop-shadow-md">
      &#xA1;&#xDA;nete a <span class="text-blue-400">{{ companyName }}</span>!
    </h1>
    <p class="text-gray-300 text-base mt-2 font-light whitespace-nowrap">
      Buscamos talento como el tuyo. &#x00BF;Te unes a nuestro equipo?
    </p>    
  </header>
  
  <div class="text-center bg-gray-100 p-6">
    <img src="assets/img/emailpicture.png" alt="Oferta Laboral en {{ companyName }}" class="mx-auto rounded-lg shadow-lg w-full max-w-md">
  </div>

  <main class="p-6 text-gray-700">
    <p class="text-lg leading-relaxed text-gray-800">
      En <strong>{{ companyName }}</strong>, buscamos un <strong>{{ jobTitle }}</strong> para unirse a nuestro equipo.
    </p>

    <section class="mt-6">
      <h2 class="text-xl font-semibold text-gray-900 border-l-4 border-blue-500 pl-3"> Ubicaci&#xF3;n</h2>
      <p class="mt-2 text-gray-700">{{ location }}</p>
    </section>

    <section class="mt-6">
      <h2 class="text-xl font-semibold text-gray-900 border-l-4 border-blue-500 pl-3"> Salario</h2>
      <p class="mt-2 text-gray-700">{{ salary }}</p>
    </section>

    <section class="mt-6">
      <h2 class="text-xl font-semibold text-gray-900 border-l-4 border-blue-500 pl-3"> Experiencia requerida</h2>
      <p class="mt-2 text-gray-700">{{ experience }}</p>
    </section>

    <section class="mt-6">
      <h2 class="text-xl font-semibold text-gray-900 border-l-4 border-blue-500 pl-3"> Requisitos</h2>
      <ul class="mt-4 space-y-3 list-disc pl-6 text-gray-700">
        <li *ngFor="let req of requirements">{{ req }}</li>
      </ul>
    </section>
  </main>

  <section class="text-center py-6">
    <a [href]="getMailtoLink()"
      class="inline-block px-6 py-2 border border-blue-600 text-blue-600 rounded-lg text-lg font-semibold transition-all duration-300 hover:bg-blue-600 hover:text-white">
      Postula Ahora
    </a>
  </section>  
</section>
